import { jobCreators } from '../behavior/jobCreators-sidecar'
import { jobs } from '../behavior/jobs-sidecar'
import { assert } from '../lib/assert-sidecar'
import { scene } from '../main/scene-sidecar'
import { cargoes } from '../entities/cargoes-sidecar'
import { IMachine } from './machines'
import { spriteMap } from '../main/spriteMap-sidecar'
import { anims } from '../engine/anims-sidecar'
import { machinesAnims } from './machinesAnims-sidecar'
import { common } from '../main/common-sidecar'

import { machines } from './machines-sidecar'

function ensure(obj: IMachine) {
  machines.ensureType(obj, 'reactor-em')
}

const refillRate = 1

export function onCreate(obj: IMachine) {
  ensure(obj)
  obj.onUpdate = onUpdate
  let jc = jobCreators.create(
    () => {
      if (obj.batterySupply > 0) {
        return false
      }

      if (!cargoes.existsOfType('battery')) {
        return false
      }

      return true
    },
    () => {
      let j = jobs.create('fill-battery')
      j.machine = obj
      return j
    },
  )
  obj.jobCreators.push(jc)
}

export function onUpdate(obj: IMachine) {
  ensure(obj)
  let ds = common.getUpdateDeltaScaled()
  let ctx = scene.getContext()
  if (obj.batterySupply > 0) {
    obj.batterySupply -= refillRate * ds
    if (obj.batterySupply <= 0) {
      obj.batterySupply = 0
      let cg = cargoes.create('power')
      cargoes.moveToTile(cg, ctx.mapShip, obj.i + 1, obj.j)
    }

    // spriteMap.setFrame(obj.image, obj.data.frames[])
    machinesAnims.playAnim(obj, machinesAnims.all.reactorGo)
  } else {
    // spriteMap.setFrame(obj.image, obj.data.frames[1])
    machinesAnims.playAnim(obj, machinesAnims.all.reactorStop)
  }
  machinesAnims.updateAnim(obj)
  // let ctx = scene.getContext()
  // if (obj.waterSupply <= 0) {
  // } else {
  //   obj.waterSupply = 0
  //   let cg = cargoes.create('water')
  //   cargoes.moveToTile(cg, ctx.mapShip, obj.i + 1, obj.j)
  // }
}
